import React, {useState, useEffect} from 'react'
import { Paper, Button } from '@mui/material';
import Loader from '../panel/loader';
import FormDialog from '../panel/modal';
import AddNoticeForm from '../form/addNoticeForm';
import ViewNotice from '../table/viewNotice';


const AddNotice = () => {


    const [load, setLoad] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [modalData , setModalData] = React.useState();

    const handleClickOpen = (data) => {
        setOpen(true);
        setModalData(data)
        // console.log(data ,'data');
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <>
        <div className="row">
                <Paper>
                    <div className="col-12 d-flex justify-content-between p-2">
                        <div></div>
                        <Button variant='contained' onClick={handleClickOpen}>+Add Notice</Button>
                    </div>
                    <FormDialog form={<AddNoticeForm handleClose={handleClose} modalData={modalData} />} title='Add Notice' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                </Paper>
                {load && <Loader />}

                <Paper>
                    <div className="col-12">
                        <ViewNotice handleClickOpen={handleClickOpen} />
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default AddNotice;